import React, { useState, useEffect } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import { Card } from "react-bootstrap";

function CityBarChart() {
  const [citiesData, setCitiesData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [venditeResponse, provinceResponse] = await Promise.all([
          fetch("mancata_vendita_dashboard.json"),
          fetch("province.json"),
        ]);

        if (!venditeResponse.ok || !provinceResponse.ok) {
          throw new Error("Errore nel caricamento dei file JSON");
        }

        const venditeData = await venditeResponse.json();
        const provinceData = await provinceResponse.json();

        console.log("📊 Dati vendite ricevuti:", venditeData);
        console.log("📌 Dati province ricevuti:", provinceData);

        // Creiamo la mappa delle province (Sigla -> Nome)
        const provinceMap = {};
        provinceData.forEach((item) => {
          provinceMap[item.sigla.toUpperCase()] = item.nome;
        });

        console.log("🗺️ Mappa province generata:", provinceMap);

        const transformedData = {};
        venditeData.SUD.localita.forEach((item) => {
          console.log("🧐 Elemento analizzato:", item);

          const sigla = item.provincia
            ? item.provincia.toUpperCase()
            : "SCONOSCIUTA";
          const provinciaNome = provinceMap[sigla] || sigla; // Se non trova, lascia la sigla

          console.log(`🔄 Sigla: ${sigla} → Provincia: ${provinciaNome}`);

          const valore = item.Valore ? parseFloat(item.Valore.replace(",", ".")) : 0;
          const numero = parseInt(item.numero_doc, 10) || 0;

          if (!transformedData[provinciaNome]) {
            transformedData[provinciaNome] = {
              provincia: provinciaNome,
              valore: 0,
              numero: 0,
            };
          }

          transformedData[provinciaNome].valore += valore;
          transformedData[provinciaNome].numero += numero;
        });

        console.log("✅ Dati trasformati e aggregati:", transformedData);

        // Ordinare per valore decrescente e prendere le prime 5 province
        const sortedData = Object.values(transformedData).sort(
          (a, b) => b.valore - a.valore
        );
        const topProvinces = sortedData.slice(0, 5);

        setCitiesData([...topProvinces]); // Forza re-render in React
      } catch (error) {
        console.error("❌ Errore durante il fetch:", error);
      }
    };

    fetchData();
  }, []);

  const formatToEuro = (amount) => {
    return new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR",
    }).format(amount);
  };

  const maxXValue =
    Math.max(...citiesData.map((dataPoint) => dataPoint.valore), 0) + 100;

  return (
    <Card className="ombra ordini-ora card-home border-light hover-effect">
      <div className="mt-1 mx-auto">
        <p className="text-title3 p-1 mt-2">
          ORDINI RICEVUTI - PROVINCE
        </p>
      </div>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          className="rounded"
          data={citiesData}
          layout="vertical"
          margin={{
            top: 20,
            right: 20,
            left: 75,
            bottom: 20,
          }}
        >
          <CartesianGrid />
          <XAxis
            fill="black"
            className="fw-bold"
            style={{ fontSize: "0.6em" }}
            type="number"
            dataKey="valore"
            domain={[0, maxXValue]}
            tickFormatter={(value) => formatToEuro(value)}
          />{" "}
          <YAxis
            dataKey="provincia"
            type="category"
            hide="true"
            fill="black"
            className="fw-bold"
            style={{ fontSize: "0.6em" }}
          />
          <Bar dataKey="valore" fill="#b9b9b9" name="Numero di Persone">
            <LabelList
              dataKey="valore"
              formatter={(value) => formatToEuro(parseFloat(value))}
              position="left"
              fill="black"
              className="fw-bold"
              style={{ fontSize: "0.7em" }}
            />
            <LabelList
              dataKey="provincia"
              position="insideLeft"
              fill="black"
              className="fw-bold"
              style={{ fontSize: "0.6em", textTransform: "uppercase" }}
            />
            <LabelList
              dataKey="numero"
              position="right"
              fill="black"
              className="fw-bold"
              style={{ fontSize: "0.6em" }}
            />
          </Bar>
          <Tooltip />
        </BarChart>
      </ResponsiveContainer>
    </Card>
  );
}

export default CityBarChart;
